// TODO: move to logic component

import { call, fork, all, put, select, takeLatest, apply } from 'redux-saga/effects'
import { notification } from 'antd'
import { find, get } from 'lodash'

import entities from '~/entities'
import { actions as applicationActions } from '~/entities/applications'
import { actions as userActions } from '~/entities/users'
import { workers as shopWorkers } from '~/entities/shops'
import { workers as shopRoleWorkers } from '~/entities/shop-roles'

import { selector as configSelector, actions as configActions, fullPush, saveConfig, clearConfig } from '~/config'

import rootLogic from '~/scenes/logic'

function * notAuthorizedWorker() {
  yield put(fullPush('/login/'));
}

function * initWorker() {
  try {
    const config = yield select(configSelector);
    const { token, activeShop, language } = config;
    if(token) {
      const shops = yield call(shopWorkers.fetchList);
      const shopRoles = yield call(shopRoleWorkers.fetchList);
      if(shops && shops.length > 0) {
        let foundShop = activeShop ? find(shops, {url: activeShop}) : null;
        if(!foundShop) {
          foundShop = shops[0]
        }
        const default_language = get(foundShop, 'checkout_settings.default_language', 'et')
        const allowed_languages = get(foundShop, 'checkout_settings.languages', [default_language])
        yield put(configActions.setActiveShop(foundShop.url, foundShop.id));
        if(allowed_languages.indexOf(language) === -1) {
          yield put(configActions.setLanguage(allowed_languages[0] || default_language));
        }
        yield put(rootLogic.actions.alreadyLoggedIn());
        yield put(applicationActions.fetchList.request());
        yield put(userActions.fetchCurrentUser.request());
      }else {
        notification.error({
          message: 'Error logging in',
          description: 'Unable to load your shop'
        });
        yield call(notAuthorizedWorker);
      }
    }else {
      yield call(notAuthorizedWorker);
    }

  } catch (e) {
    console.error(e);
  }
}

function * initNotificationsWorker() {
  try {
    if(typeof window !== 'undefined' && window.OneSignal) {
      const OneSignal = window.OneSignal;
      const config = yield select(configSelector);
      const { token, activeShop } = config;

      const shops = yield select(entities.selectors.shops);

      const shop = find(shops, {url: activeShop});

      if(shop) {
        const shouldBeSubscribed = get(shop, 'admin_settings.push_notifications', false);
        const subscribed = yield apply(OneSignal, OneSignal.getSubscription);
        const isPushEnabled = yield apply(OneSignal, OneSignal.isPushNotificationsEnabled);

        if(shouldBeSubscribed) {
          if(!isPushEnabled) {
            yield apply(OneSignal, OneSignal.registerForPushNotifications, [{modalPrompt: true}]);
          } else if(!subscribed) {
            yield apply(OneSignal, OneSignal.setSubscription, [true]);
          }
          const response = yield apply(OneSignal, OneSignal.sendTag, ['shop_url', shop.url]);
        }else {
          if(subscribed) {
            yield apply(OneSignal, OneSignal.setSubscription, [false]);
          }
        }
      }
    }

  } catch (e) {
    console.error(e);
  }
}

function * saveToken(action) {
  saveConfig('token-new', action.payload.token);
}

function * saveActiveShop(action) {
  saveConfig('activeShop', action.payload.shopUrl);
  saveConfig('activeShopId', action.payload.shopId);
}

function * logout() {
  clearConfig('token');
  clearConfig('token-new');
  clearConfig('activeShop');
  clearConfig('activeShopId');
  if(typeof window !== 'undefined') {
    window.location.replace('/login/');
  }
}

function * setLanguage(action) {
  saveConfig('language', action.payload.language);
  if(typeof window !== 'undefined') {
    window.location.reload();
  }
}

function * setUILanguage(action) {
  saveConfig('uiLanguage', action.payload.language);
  if(typeof window !== 'undefined') {
    window.location.reload();
  }
}

export default function * rootWorker () {
  try {
    yield all([
      fork(initWorker),
      takeLatest(rootLogic.actions.loginSuccess().type, initWorker),
      takeLatest(configActions.setToken().type, saveToken),
      takeLatest(configActions.setActiveShop().type, saveActiveShop),
      takeLatest(configActions.userLogout().type, logout),
      takeLatest(configActions.setLanguage().type, setLanguage),
      takeLatest(configActions.setUILanguage().type, setUILanguage),
      //takeLatest(rootLogic.actions.alreadyLoggedIn().type, initNotificationsWorker),
    ])
  } catch (e) {
    console.error(e);
  }
}
